
function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};
var monthsShort = [ 'Jan',     'Feb',      'Mar',   'Apr',   'May', 'Jun',  'Jul',  'Aug',    'Sep',       'Oct',     'Nov',      'Dec'];
var months =      [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
function dateSQlToHuman($value){
    let arrayValue = $value.split("-");
    let date = new Date(Number(arrayValue[0]),Number(arrayValue[1])-1,Number(arrayValue[2]));                 
    let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
    let mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(date);
    let da = new Intl.DateTimeFormat('en', { day:    '2-digit' }).format(date)
}

function dateHumanToSQl(date){
    if(typeof date !=='undefined'){
        let arrayValue = date.replace(',', '').split(" ");  
        var year  =  arrayValue[2];
        var month = (Number(monthsShort.indexOf( arrayValue[0]) )+1);
        month = `0${month}`.slice(-2);
        var day   = arrayValue[1];
        day = `0${day}`.slice(-2);
        var value = year+'-'+month+'-'+day;
        return value;
    }
} 


$( function( ) {

   if (window.location.hash) {
      var target = location.hash.split('#');
      setTimeout(function () {
        scroll2element($('#'+target[1]));
      }, 500);
    }


    $('.burger').click(function(){
        
        $('body').toggleClass('show-menu');
        return false;
    }); 
    $('.account-burger').click(function(){
        $('body').toggleClass('show-account-menu');
        return false;
    }); 
    $('.responsive-overlay').click(function(){
        $('body').removeClass('show-menu');
        return false;
    });  
    $('.page-body').addClass('loaded');  
    
    
    $( document ).on( 'click', '[data-action="load-more"]', function( ) {
        var p = $( this ).closest( '.partial' ),
        caller = $( this ),
        page = p.data( 'page' );        
        if ( page == null || page < 1 ) {
            page = 1;
        }
        p.data( 'page' , page+1 );
        caller.addClass( 'loading' );
        append_partial( p, function( ) {
            caller.removeClass( 'loading' );
        } );
        return false;      
    } ); 


    $('.instant-partial').each(function(){
        var $thePartial = $(this);         
        load_partial_instantly( $thePartial);       
    });

    if ( $( window ).scrollTop( ) > 50 ) {
        $( 'body' ).addClass( 'scrolled' );
    }
    var lastScrollTop = 0;
    $( document ).on( 'scroll', function( ) {
        _scrollTop = $( window ).scrollTop( );
        if ( _scrollTop >= 50 ) {
            $( 'body' ).addClass( 'scrolled' );           
        } else {
            $( 'body' ).removeClass( 'scrolled' );
        }
    } );
    initForm( 'body' );
    waypoints();
});

/* Function to animate height: auto */
function autoHeightAnimate(element, time){
    var     curHeight = element.height(), // Get Default Height
            autoHeight = element.css('height', 'auto').height(); // Get Auto Height
            element.height(curHeight); // Reset to Default Height
            element.stop().animate({ height: autoHeight }, time); // Animate to Auto Height
}


function scroll2position( pos, t ) {
    $( 'html, body' ).animate( {
        scrollTop: pos
    }, t || 500 );
}

function scroll2element( el ) {
    var position = $( el ).offset( );
    var $padding = $( 'body' ).css( 'paddingTop' ).replace( 'px', '' );
    var y = position.top - $padding - $('header').height() - 100;

    $( 'html, body' ).stop( ).animate( {
        scrollTop: y
    }, 'slow' );

}



function dd( d ){
    console.log(d);
}
function partialPager( $this,$page ){
    var  $thePartial = $this.closest('.partial');
    $thePartial.attr('data-page',$page);     
    load_partial( $thePartial);    
}
function partialSortTrigger( $this ){
    var  $thePartial = $this.closest('.partial');
    var $way  = $this.data('sortway');
    var $term = $this.data('sortterm');
    $thePartial.attr('data-sortway',$way);     
    $thePartial.attr('data-sortterm',$term);     
    load_partial( $thePartial);    
}

function waypoints(  ) {
    $( '.waypoint-animate:not(.way-point-ready)' ).each( function( ) {

        var $offset = typeof $(this).data('waypoint-offset')!=='undefined' ? $(this).data('waypoint-offset') :'90%'; 
        $( this ).waypoint( function( ) {
            $( this.element ).addClass( 'shown' );
        }, {
            offset: $offset
        } );
        $( this ).addClass( 'way-point-ready' );
    });
}
function formatData( data ) {
    if ( !data.id ) {
        return data.text;
    }
    var $result = $(
        '<span><img src="/assets/frontend/default/img/assets/' + data.text.toLowerCase( ) + '.png"/> ' + data.text + '</span>'
    );
    return $result;
};





function loadScript( url, callback ) {
    jQuery.ajax( {
        url: url,
        dataType: 'script',
        success: callback,
        async: true
    } );
} 
function load_css( t ) {
    $( 'head' ).append( '<link rel="stylesheet" href="' + t + '" type="text/css" />' );
}